export default "__VITE_ASSET__Ca_xzbSz__"